import { useState } from "react";
import { Logo } from "@/components/Logo";
import { scrollToHash } from "@/lib/scroll";
import { TosModal } from "@/components/landing/TosModal";
import { PrivacyPolicyModal } from "@/components/landing/PrivacyPolicyModal";
import { TrackOrderModal } from "@/components/landing/TrackOrderModal";

export const Footer = () => {
  const [tosOpen, setTosOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [trackOpen, setTrackOpen] = useState(false);

  return (
  <footer data-testid="site-footer" className="relative border-t border-[#E4E4E7] overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
      <div className="flex flex-col md:flex-row justify-between gap-10 mb-16">
        <div className="flex items-center gap-3 text-[#09090B]">
          <Logo className="w-8 h-8" />
          <span className="font-display font-bold tracking-[0.18em] text-sm uppercase">Aetheris Labs</span>
        </div>
        <div className="flex flex-wrap gap-10 font-mono-clinical text-xs tracking-[0.2em] uppercase text-[#71717A]">
          <a href="#products" data-testid="footer-link-products" onClick={scrollToHash("#products")} className="hover:text-[#6D28D9] transition-colors">Compounds</a>
          <a href="#quality" data-testid="footer-link-quality" onClick={scrollToHash("#quality")} className="hover:text-[#6D28D9] transition-colors">Quality</a>
          <button type="button" data-testid="footer-link-track" onClick={() => setTrackOpen(true)} className="uppercase tracking-[0.2em] hover:text-[#6D28D9] transition-colors">Track Order</button>
          <button type="button" data-testid="footer-link-terms" onClick={() => setTosOpen(true)} className="uppercase tracking-[0.2em] hover:text-[#6D28D9] transition-colors">Terms</button>
          <button type="button" data-testid="footer-link-privacy" onClick={() => setPrivacyOpen(true)} className="uppercase tracking-[0.2em] hover:text-[#6D28D9] transition-colors">Privacy</button>
          <a href="/admin/login" data-testid="footer-link-admin" className="hover:text-[#6D28D9] transition-colors">Admin</a>
        </div>
      </div>

      <h2 data-testid="footer-wordmark" className="text-outline font-display font-black uppercase leading-[0.85] tracking-tighter text-[clamp(4rem,17vw,17rem)] select-none text-center">
        Aetheris
      </h2>

      <div className="mt-16 pt-8 border-t border-[#E4E4E7] flex flex-col md:flex-row justify-between gap-6">
        <p data-testid="footer-disclaimer" className="text-xs text-[#A1A1AA] max-w-xl leading-relaxed">
          All products are sold strictly for laboratory research purposes only. Not for human or veterinary
          consumption, diagnostic or therapeutic use. Statements on this site have not been evaluated by any
          regulatory authority. By purchasing, you confirm you are a qualified researcher.
        </p>
        <p className="font-mono-clinical text-[10px] tracking-[0.25em] uppercase text-[#A1A1AA]">
          © 2026 Aetheris Labs — All rights reserved
        </p>
      </div>
    </div>
    <TosModal open={tosOpen} onClose={() => setTosOpen(false)} />
    <PrivacyPolicyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    <TrackOrderModal open={trackOpen} onClose={() => setTrackOpen(false)} />
  </footer>
  );
};
